import React from 'react';
import EditDrawer from './EditDrawer';
import Field from '../../Field';
import { FAMILY_TEXT_MAX } from '../../../domain/people';
import s from './editStudent.module.css';

// Drawer 5 of five — the pencil on the student's Family Contacts tab (#120).
//
// It edits one field: `families/{id}.lastName`, the family's own name — what
// an invoice is addressed to, what the families list sorts by, and a property
// of no contact. Contacts are `familyContacts` records, edited by
// `FamilyContactDrawer` beside this file (#319).
//
// A knowing divergence: MMS has no family edit surface — its family page has
// two links and one button, and a family's displayed name is its contact's
// name. We keep a real `lastName` on the family document (`familyDisplayName`
// reads it), so it needs an editor, or a studio would be stuck with whatever
// the Add Student wizard derived from a parent's surname. Deriving it from the
// billing contact, as MMS does, would change an invoice's addressee whenever a
// contact is edited, including on invoices already sent. `normaliseFamily` in
// domain/people.js writes the field.
//
// `familyNameErrors` refuses it empty: `familyDisplayName` falls back to the
// literal word "Family", which every invoice would then be made out to.
export default function EditFamilyDrawer({
  open, form, errors, saving, onChange, onClose, onSave,
}) {
  if (!open) return null;

  return (
    <EditDrawer open title="Family Account" saving={saving} onClose={onClose} onSave={onSave}>
      <div className={[s.spaced, s.medium].join(' ')}>
        <Field
          label="Family Name" htmlFor="edit-family-name" required
          hint="What invoices are addressed to"
          error={errors.lastName}
        >
          <input
            id="edit-family-name" className={s.input} maxLength={FAMILY_TEXT_MAX.lastName}
            value={form.lastName} onChange={(e) => onChange('lastName', e.target.value)}
          />
        </Field>
      </div>
    </EditDrawer>
  );
}
